
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { RefObject, ChangeEvent } from "react";

interface FileUploadFieldProps {
  type: string;
  fileInputRef: RefObject<HTMLInputElement>;
  videoInputRef: RefObject<HTMLInputElement>;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export function FileUploadField({ type, fileInputRef, videoInputRef, onChange }: FileUploadFieldProps) {
  return (
    <>
      {type === 'document' ? (
        <div>
          <Label htmlFor="file-upload">Επιλογή Εγγράφου</Label>
          <div className="mt-1">
            <Input 
              id="file-upload"
              ref={fileInputRef}
              type="file" 
              accept=".pdf,.doc,.docx,.txt,.ppt,.pptx,.xls,.xlsx"
              onChange={onChange} 
            />
          </div>
        </div>
      ) : (
        <div>
          <Label htmlFor="video-upload">Επιλογή Βίντεο</Label>
          <div className="mt-1">
            <Input 
              id="video-upload"
              ref={videoInputRef}
              type="file" 
              accept="video/*,.mp4,.mov,.avi,.wmv"
              onChange={onChange} 
            />
          </div>
        </div>
      )}
    </>
  );
}
